import React from "react";
import * as Mui from "@mui/material";
import { AgentPublicBio } from "model/agent";
import { RichTextEditor } from "component/shared/rich-text-editor";
import { visibleLen, ValidationErrors } from "../validation";
import * as styles from "../styles";

interface Props {
	publicBio: AgentPublicBio;
	errors: ValidationErrors;
	onUpdateField: <K extends keyof AgentPublicBio>(field: K, value: AgentPublicBio[K]) => void;
}

export const AboutSection: React.FC<Props> = ({
	publicBio,
	errors,
	onUpdateField,
}) => {
	const aboutBodyLength = visibleLen(publicBio.aboutBody);

	return (
		<>
			<Mui.Grid item xs={12}>
				<Mui.Typography style={styles.sectionTitleWithDescription}>
					About / Bio
				</Mui.Typography>
				<Mui.Typography style={styles.descriptionText}>
					Write a bio that will appear on your public bio page. Include your experience, specialties, service areas, and anything that helps clients get to know you.
				</Mui.Typography>
			</Mui.Grid>

			<Mui.Grid item xs={12}>
				<RichTextEditor
					onChange={(text) => onUpdateField('aboutBody', text)}
					toolbarId="aboutBody"
					value={publicBio.aboutBody || ''}
				/>
				<Mui.Box display="flex" justifyContent="flex-end" mt={0.5}>
					<Mui.Typography
						variant="caption"
						color={errors.aboutBody ? "error" : "textSecondary"}
						data-error={!!errors.aboutBody}
					>
						{errors.aboutBody || `${aboutBodyLength}/5000 characters`}
					</Mui.Typography>
				</Mui.Box>
			</Mui.Grid>
		</>
	);
};
